const style = {
  flex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  main: {
    width: '950px',
    height: '500px'
  },
  mobileImg: {
    width: '100%',
    height: 'auto',
    borderRadius: '3px'
  },
  img: {
    width: '80%',
    height: 'auto',
  },
  imageContainer: {
    maxWidth: '800px',
    width: '100%',
    height: 'auto',
  },
  outline: {
    backgroundColor: '#395E66',
    fontFamily: 'Lexend Deca, sans-serif',
    padding: '2rem',
    margin: '2rem auto',
    borderRadius: '5px',
    boxShadow: 'var(--box-shadow, -1px 0px 38px 8px rgba(0,0,0,0.51))'
  },
  buttonContainer: {
    maxWidth: '860px',
    backgroundColor: 'white',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'row',
    padding: 'none !important',
    alignItems: 'center',
    justifyContent: 'space-around',
    background: 'var(--header-text, #F0F8FF)'
  },
  cursor: {
    cursor: 'pointer',
  },
  marginBottom: {
  },
  projectTitle: {
    textAlign: 'center',
    marginBottom: '1rem',
    color: 'var(--header-text, #F0F8FF)'
  },
  projectDetailTitle: {
    textAlign: 'center',
    marginBottom: '1rem',
    color: 'var(--header-background, #071013)'
  },
  cardWidth: {
    width: '100%',
    maxWidth: '800px'
  },
};

export default style;
